// extracted by mini-css-extract-plugin
export default {"header":"SocialHeader_header__BPjlA","logo":"SocialHeader_logo__FaTfO","socials":"SocialHeader_socials__2JIhN","icon":"SocialHeader_icon__r7DOO"};